module.exports = __webpack_public_path__ + "482b26b875c1db0d1b4470e686be7b81.png";